import { render, staticRenderFns } from "./MaterielType.vue?vue&type=template&id=01658b10"
import script from "./MaterielType.vue?vue&type=script&lang=js"
export * from "./MaterielType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01658b10')) {
      api.createRecord('01658b10', component.options)
    } else {
      api.reload('01658b10', component.options)
    }
    module.hot.accept("./MaterielType.vue?vue&type=template&id=01658b10", function () {
      api.rerender('01658b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/base/dictionary/medicinedic/MaterielType.vue"
export default component.exports